import { useTranslation } from 'react-i18next';

/**
 * Translations for cancelling a recurring payment.
 */
const useCancelTranslations = () => {
  const { t } = useTranslation();

  const cancel = (translationKey: string) => t(`account.recurringPayment.cancel.${translationKey}`);

  return {
    heading: cancel('heading'),
    text: cancel('text'),
    warning: cancel('warning'),
    areYouSure: cancel('areYouSure'),
    success: {
      heading: cancel('success.heading'),
      text: cancel('success.text'),
    },
    failure: {
      heading: cancel('failure.heading'),
      text: cancel('failure.text'),
    },
  };
}

export default useCancelTranslations;